// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v8G2","label":"styles_label__GjTcy"};